export default __webpack_public_path__ + "static/media/loader-clip.5a8fd63b.svg";